/**
 * Client utility per better-auth dal frontend.
 *
 * Usiamo fetch diretto sugli endpoint /api/auth/* invece di importare
 * il SDK better-auth client (tiene il bundle leggero e ci dà controllo
 * esplicito sulle chiamate).
 */

export type SessionUser = {
  id: string;
  email: string;
  name?: string | null;
  role?: string;
} | null;

const PHASE_SESSION_KEY = "prora_phase_user";

function readPhaseSession(): SessionUser {
  try {
    const raw = window.localStorage.getItem(PHASE_SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as NonNullable<SessionUser>;
    return parsed?.id && parsed?.email ? parsed : null;
  } catch {
    return null;
  }
}

export async function fetchSession(): Promise<SessionUser> {
  try {
    const r = await fetch("/api/auth/get-session", { credentials: "include" });
    if (!r.ok) return readPhaseSession();
    const data = (await r.json()) as { user?: SessionUser };
    return data?.user ?? readPhaseSession();
  } catch {
    return readPhaseSession();
  }
}

export async function requestMagicLink(email: string): Promise<{ ok: boolean; error?: string }> {
  try {
    const r = await fetch("/api/auth/sign-in/magic-link", {
      method: "POST",
      headers: { "content-type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ email, callbackURL: "/" }),
    });
    if (!r.ok) {
      const text = await r.text();
      return { ok: false, error: text || `HTTP ${r.status}` };
    }
    return { ok: true };
  } catch (e) {
    return { ok: false, error: e instanceof Error ? e.message : String(e) };
  }
}

export function startPhaseSession(label?: string): SessionUser {
  const raw = label?.trim();
  const email = raw && raw.includes("@") ? raw : "fase@prora.local";
  const user = {
    id: "phase-admin",
    email,
    name: "Accesso fase",
    role: "admin",
  };
  window.localStorage.setItem(PHASE_SESSION_KEY, JSON.stringify(user));
  return user;
}

export function phaseAuthHeaders(): HeadersInit {
  return readPhaseSession() ? { "x-prora-phase-login": "1" } : {};
}

export async function signOut(): Promise<void> {
  try { window.localStorage.removeItem(PHASE_SESSION_KEY); } catch {}
  await fetch("/api/auth/sign-out", { method: "POST", credentials: "include" });
}
